import React from "react";
import * as CHQ from "chq";

import { EventLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type EventHostingCappedNotificationProps = {
  notification: CHQ.NotificationEventHostingCapped;
  tabIndex?: number;
};

const EventHostingCappedNotification: React.FC<EventHostingCappedNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <EventLink event={entity.event} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>has hit its attendee cap</Trans>
  </NotificationBody>
);

export default EventHostingCappedNotification;
